import { Menu } from './menu.model'; 

export const menuItems = [ 
    new Menu (10, 'ADMIN_NAV.DASHBOARD', '/compte-utilisateur', null, 'dashboard', null, false, 0),
    // new Menu (20, 'ADMIN_NAV.MENU_ITEMS', null, null, 'person', null,true, true, 0),  
    // new Menu (21, 'ADMIN_NAV.VERIFICATION_COMPTE', '/compte-utilisateur/mon-compte/verification-compte', null, 'verified_user', null,true, false, 20), 
    //new Menu (22, 'ADMIN_NAV.MES_COORDONNEES', '/compte-utilisateur/mon-compte/mes-coodonnees', null, 'verified_user', null, false, 20),
    
    // new Menu (22, 'ADMIN_NAV.MES_COORDONNEES', '/compte-utilisateur/mon-compte/mes-coodonnees', null, 'domain', null,true, false, 20),
    // new Menu (23, 'ADMIN_NAV.VALIDATION_PERMIS', '/compte-utilisateur/mon-compte/permis', null, 'drive_eta', null,true, false, 20),
    // new Menu (23, 'ADMIN_NAV.VALIDATION_CNI', '/compte-utilisateur/mon-compte/cni', null, 'perm_identity', null,true, false, 20),
    
    // new Menu (24, 'ADMIN_NAV.MES_PARAMETRES', '/compte-utilisateur/mon-compte/mes-parametres', null, 'settings', null,true, false, 20),
    new Menu (30, 'ADMIN_NAV.MES_VEHICULES', null, null, 'directions_car', null,true, 0),  
    new Menu (31, 'ADMIN_NAV.GESTION_VEHICULE', '/compte-utilisateur/mes-vehicules/liste-vehicule', null, 'commute' , null, false, 30), 
    new Menu (32, 'ADMIN_NAV.MES_DISPONIBILITES', '/compte-utilisateur/mes-vehicules/mes-disponibilites', null, 'verified_user', null, false, 30),
    new Menu (40, 'ADMIN_NAV.MES_LOCATIONS', null, null, 'favorite', null, true, 0),  
    new Menu (41, 'ADMIN_NAV.LOCATAIRE', '/compte-utilisateur/mes-locations/locataire', null, 'swap_horiz', null, false, 40), 
    
    new Menu (42, 'ADMIN_NAV.PROPRIETAIRE', '/compte-utilisateur/mes-locations/proprietaire', null, 'swap_horiz', null, false, 40),


    new Menu (70, 'ADMIN_NAV.MES_PROLONGATIONS.NAME', null, null, 'event', null, true, 0),  
    new Menu (71, 'ADMIN_NAV.MES_PROLONGATIONS.LOCATAIRE', '/compte-utilisateur/mes-prolongations/locataire', null, 'swap_horiz', null, false, 70), 
    
    new Menu (72, 'ADMIN_NAV.MES_PROLONGATIONS.PROPRIETAIRE', '/compte-utilisateur/mes-prolongations/proprietaire', null, 'swap_horiz', null, false, 70),

    //new Menu (42, 'ADMIN_NAV.PROPRIETAIRE', '/compte-utilisateur/mes-locations/proprietaire', null, 'verified_user', null, false, 40),
    new Menu (50, 'ADMIN_NAV.MES_PAIEMENTS', null, null, 'monetization_on', null, true, 0),  
    new Menu (51, 'ADMIN_NAV.PORTE_MONAIE', '/compte-utilisateur/mes-paiements/mon-porte-monaie-valide', null, 'account_balance_wallet', null, false, 50), 
    new Menu (52, 'ADMIN_NAV.PAIEMENTS', '/compte-utilisateur/mes-paiements/mes-paiements', null, 'payment', null, false, 50), 
    new Menu (53, 'ADMIN_NAV.REVENUS', '/compte-utilisateur/mes-paiements/mes-revenus', null, 'money', null, false, 50),
    new Menu (54, 'ADMIN_NAV.AVOIRS', '/compte-utilisateur/mes-paiements/mes-avoirs', null, 'money', null, false, 50),


    new Menu (60, 'ADMIN_NAV.MES_LITIGES', null, null, 'report_problem', null, true, 0), 
    new Menu (61, 'ADMIN_NAV.LITIGE', '/compte-utilisateur/litige', null, 'sync_problem', null, false, 60),
    new Menu (62, 'ADMIN_NAV.SINISTRE', '/compte-utilisateur/sinistre', null, 'sync_problem', null, false, 60),

    new Menu (100, 'Etats des lieux', '/compte-utilisateur/constat', null, 'report', null, false, 0),

    new Menu (110, 'ADMIN_NAV.CHAT.NAME', null, null, 'mail_outline', null, true, 0), 
    new Menu (111, 'ADMIN_NAV.CHAT.LODGER', '/compte-utilisateur/message/locataire', null, 'chat_bubble_outline', null, false, 110),
    new Menu (112, 'ADMIN_NAV.CHAT.OWNER', '/compte-utilisateur/message/proprietaire', null, 'chat_bubble_outline', null, false, 110),

    new Menu (205, 'Admin', null, '/admin', 'supervisor_account', null, false, 0)

]

export const menuItemsProprietaire = [ 
    new Menu (1, 'ADMIN_NAV.DASHBOARD', '/compte-utilisateur', null, 'dashboard', null, false, 0),
    
    new Menu (2, 'ADMIN_NAV.MES_VEHICULES', null, null, 'directions_car', null,true, 0),  
    new Menu (3, 'ADMIN_NAV.GESTION_VEHICULE', '/compte-utilisateur/mes-vehicules/liste-vehicule', null, 'commute' , null, false, 2), 
    new Menu (4, 'ADMIN_NAV.MES_DISPONIBILITES', '/compte-utilisateur/mes-vehicules/mes-disponibilites', null, 'verified_user', null, false, 2),
    // new Menu (5, 'ADMIN_NAV.MES_LOCATIONS', null, null, 'favorite', null,true, true, 0),
    new Menu (5, 'ADMIN_NAV.MES_LOCATIONS', '/compte-utilisateur/mes-locations/proprietaire', null, 'favorite', null, false, 0),  

    // new Menu (70, 'ADMIN_NAV.MES_PROLONGATIONS.NAME', null, null, 'event', null,true, true, 0),  
    new Menu (6, 'ADMIN_NAV.MES_PROLONGATIONS.NAME', '/compte-utilisateur/mes-prolongations/proprietaire', null, 'event', null, false, 0),

    new Menu (7, 'ADMIN_NAV.MES_PAIEMENTS', null, null, 'monetization_on', null, true, 0),  
    new Menu (8, 'ADMIN_NAV.PORTE_MONAIE', '/compte-utilisateur/mes-paiements/mon-porte-monaie-valide', null, 'account_balance_wallet', null, false, 7), 
    new Menu (9, 'ADMIN_NAV.PAIEMENTS', '/compte-utilisateur/mes-paiements/mes-paiements', null, 'payment', null, false, 7), 
    new Menu (10, 'ADMIN_NAV.REVENUS', '/compte-utilisateur/mes-paiements/mes-revenus', null, 'money', null, false, 7),


    new Menu (11, 'ADMIN_NAV.MES_LITIGES', null, null, 'report_problem', null, true, 0), 
    new Menu (12, 'ADMIN_NAV.LITIGE', '/compte-utilisateur/litige', null, 'sync_problem', null, false, 11),
    new Menu (13, 'ADMIN_NAV.SINISTRE', '/compte-utilisateur/sinistre', null, 'sync_problem', null, false, 11),

    new Menu (14, 'Etats des lieux', '/compte-utilisateur/constat', null, 'report', null, false, 0),

    // new Menu (15, 'ADMIN_NAV.CHAT.NAME', null, null, 'mail_outline', null,true, true, 0), 
    new Menu (15, 'ADMIN_NAV.CHAT.NAME', '/compte-utilisateur/message/proprietaire', null, 'mail_outline', null, true, 0),

    new Menu (16, 'Admin', null, '/admin', 'supervisor_account', null, false, 0)

]

export const menuItemsLocataire = [ 
    new Menu (1, 'ADMIN_NAV.DASHBOARD', '/compte-utilisateur', null, 'dashboard', null, false, 0),
    
    // new Menu (40, 'ADMIN_NAV.MES_LOCATIONS', null, null, 'favorite', null,true, true, 0),  
    new Menu (2, 'ADMIN_NAV.MES_LOCATIONS', '/compte-utilisateur/mes-locations/locataire', null, 'favorite', null, false, 0), 
    
    // new Menu (70, 'ADMIN_NAV.MES_PROLONGATIONS.NAME', null, null, 'event', null,true, true, 0),  
    new Menu (3, 'ADMIN_NAV.MES_PROLONGATIONS.NAME', '/compte-utilisateur/mes-prolongations/locataire', null, 'event', null, false, 0), 
    

    //new Menu (42, 'ADMIN_NAV.PROPRIETAIRE', '/compte-utilisateur/mes-locations/proprietaire', null, 'verified_user', null, false, 40),
    new Menu (4, 'ADMIN_NAV.MES_PAIEMENTS', null, null, 'monetization_on', null, true, 0),  
    new Menu (5, 'ADMIN_NAV.PAIEMENTS', '/compte-utilisateur/mes-paiements/mes-paiements', null, 'payment', null, false, 4), 
    new Menu (6, 'ADMIN_NAV.AVOIRS', '/compte-utilisateur/mes-paiements/mes-avoirs', null, 'money', null, false, 4),


    new Menu (7, 'ADMIN_NAV.MES_LITIGES', null, null, 'report_problem', null, true, 0), 
    new Menu (8, 'ADMIN_NAV.LITIGE', '/compte-utilisateur/litige', null, 'sync_problem', null, false, 7),
    new Menu (9, 'ADMIN_NAV.SINISTRE', '/compte-utilisateur/sinistre', null, 'sync_problem', null, false, 7),

    new Menu (10, 'Etats des lieux', '/compte-utilisateur/constat', null, 'report', null, false, 0),

    // new Menu (110, 'ADMIN_NAV.CHAT.NAME', null, null, 'mail_outline', null,true, true, 0), 
    new Menu (11, 'ADMIN_NAV.CHAT.NAME', '/compte-utilisateur/message/locataire', null, 'mail_outline', null, false, 0),

    new Menu (205, 'Admin', null, '/admin', 'supervisor_account', null, false, 0)

]